module.exports = __webpack_public_path__ + "static/img/12.ce5fe77f.png";